import styled from 'styled-components';

export const Blog = styled.div`
        color: white;
        width: 100vw;
        background-color: #012340;
        .section__1{
                display: flex;
                justify-content: space-between;
        };
        .section_1--links{
                width: 33%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-size: 2.5em;
        }
        .section_1--links a{
                color: #04D939;
                margin: 1em 0em;
        }
        .section_1--perfilimg{
                display: flex;
                align-items: center;
                justify-content: center;
        }
        .section_1--perfilimg img{
                border-radius: 1em 1em 0em 0em;
                width: 70%;
                box-shadow: rgb(4, 217, 57) 0px 5px 15px;
                animation-name: borderanimation;
                animation-duration: 2s;
                animation-timing-function: linear;
                animation-delay: 2s;
                animation-iteration-count: infinite;
                animation-direction: alternate;
        }
        .section_1--scrolldown{
                width: 33%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
        }
        .section_1--scrolldown a{
                font-size: 2.5em;
                text-decoration: none;
                color:#04D939;
                display: block;
                transform: rotate(90deg);
        }
        //section 2
        .section__2{
                max-width: 80%;
                margin: 0 auto;
                text-align: justify;
        }
        .section__2--about{
                display: flex;
                justify-content: space-between;
        }
        .section__2--imgdContainer{
                width: 40%;
        }
        .section__2--imgBorder{
                border: 2px solid #04D939;
                border-radius: .5em;
                width: 100%;
        }
        .section__2--imgdContainer img{
                width: 100%;
                border-radius: .5em;
                transform:rotate(4deg);
                transition-duration: .5s;
        }
        .section__2--imgdContainer img:hover{
                transform:rotate(-4deg)
        }
        .section__2--about-experience{
                width: 55%;
                display: flex;
                flex-direction: column;
                align-items: center;
        }
        .section__2--expericenceTopics{
                display:flex;
                width: 100%;
                justify-content: space-between;
                margin-top: 1em;
        }
        .section__2--icon{
                font-size: 1.7em;
        }
        .section__2--expericenceTopic{
                background-color: #025939;
                display: flex;
                align-items: center;
                flex-direction: column;
                border-radius: .5em;
                padding: 1em 2em;
                width: 4.5em
        }
        .section__3{
                max-width: 80%;
                margin: 0 auto;
        }
        .section__3--skillsContainer{
                display: flex;
                justify-content: space-between;
        }
        .section__3--skills{
                background-color: #025939;
                width: 45%;
                padding: .5em 1em;
                border-radius: .5em;
        }
        .section__3--skill{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
        }
        .section__3--container{
                display: flex;
                justify-content: space-around;
                flex-wrap: wrap;
        }
        .icon{
                font-size: 2.5em;
                cursor: pointer;
        }
        .icon:hover{
                color: #04D939;
        }
        //section 4 
        .section__4{
                max-width: 80%;
                margin: 0 auto;
        }
        .section__4--projectsContainer{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
        }
        @keyframes borderanimation {
                0%   {
                        box-shadow: rgb(4, 217, 57) 0px 5px 15px;}
                100% {
                        box-shadow: rgb(2, 89, 57) 0px 0px 0px;}
        };
        @media screen and (max-width: 1230px) {
                .section__1{
                        flex-direction: column-reverse;
                }
                .section_1--scrolldown{
                        display: none;
                }
                .section_1--perfilimg{
                        margin: 0 auto;
                        width: 50%;
                }
                .section_1--links{
                        margin: 0 auto;
                        flex-direction: row;
                        justify-content: space-around;
                }

                .section__2, .section__3, .section__4 {
                        max-width: 95%;
        };
        
        }
        @media screen and (max-width: 965px) {
                
                .section__4--projectsContainer{
                        grid-template-columns: repeat(2, 1fr);
                }
                .section__2--about{
                        flex-direction: column;
                        align-items: center;
                }
                .section__2--about-experience{
                        width: 90%;
                }
                .section__2--imgdContainer{
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                }
                .section__2--imgBorder{
                        width: 80%;
                }
                .section__2--expericenceTopics{
                        justify-content: space-around;
                }
        };
        @media screen and (max-width: 600px) {
                .section_1--perfilimg{
                        margin: 0 auto;
                        width: 100%;
                }
                .section__3--skillsContainer{
                        flex-direction: column;
                        align-items: center;
                }
                .section__3--skills{
                        width: 90%;
                        margin-bottom: 1em;
                }
        };
`